import { DeleteOutlined } from '@ant-design/icons';
import { Button, InputNumber } from 'antd';

import { NumberInputWithMask } from '@app/components/RecordModal/components/RecordDetails/ui';
import { formatAmount } from '@app/shared/utils/formatAmount';

import { getRowTotal, getRowUnitPrice } from '../utils/calculations';

import type { SubscriptionServiceRow } from '../types';
import type { ColumnsType } from 'antd/es/table';

interface SubscriptionServicesColumnsHandlers {
  onChangeCount: (serviceId: number, count: number | null) => void;
  onChangeDiscountAmount: (serviceId: number, amount: number) => void;
  onChangeDiscountPercent: (serviceId: number, percent: number) => void;
  onRemove: (serviceId: number) => void;
}

export const getSubscriptionServicesColumns = ({
  onChangeCount,
  onChangeDiscountAmount,
  onChangeDiscountPercent,
  onRemove,
}: SubscriptionServicesColumnsHandlers): ColumnsType<SubscriptionServiceRow> => [
  {
    title: 'Услуга',
    key: 'service',
    width: 220,
    render: (_, { Name, CategoryName }) => (
      <div className="SubscriptionModal__service">
        <span>{Name}</span>
        {CategoryName && (
          <span className="SubscriptionModal__service-category">
            {CategoryName}
          </span>
        )}
      </div>
    ),
  },
  {
    title: 'Кол-во',
    key: 'count',
    width: 100,
    render: (_, { ClientServiceId, Count }) => (
      <InputNumber
        min={1}
        precision={0}
        value={Count}
        onChange={(value) => onChangeCount(ClientServiceId, value)}
        className="SubscriptionModal__number-input"
        data-testid="subscription-row-count"
      />
    ),
  },
  {
    title: 'Цена по прайсу',
    key: 'price',
    width: 130,
    align: 'right',
    render: (_, { Price }) => `${formatAmount(Price)} ₽`,
  },
  {
    title: 'Скидка',
    key: 'discount',
    width: 240,
    render: (_, { ClientServiceId, DiscountAmount, DiscountPercent }) => (
      <div className="SubscriptionModal__discount">
        <NumberInputWithMask
          value={DiscountAmount}
          suffix="₽"
          dataTestId="subscription-row-discount-amount"
          onChange={(value) => onChangeDiscountAmount(ClientServiceId, value)}
        />
        <NumberInputWithMask
          value={DiscountPercent}
          suffix="%"
          dataTestId="subscription-row-discount-percent"
          onChange={(value) => onChangeDiscountPercent(ClientServiceId, value)}
        />
      </div>
    ),
  },
  {
    title: 'Цена в абонементе',
    key: 'unitPrice',
    width: 150,
    align: 'right',
    render: (_, row) => `${formatAmount(getRowUnitPrice(row))} ₽`,
  },
  {
    title: 'Сумма',
    key: 'total',
    width: 120,
    align: 'right',
    render: (_, row) => `${formatAmount(getRowTotal(row))} ₽`,
  },
  {
    title: '',
    key: 'actions',
    width: 48,
    align: 'right',
    fixed: 'right',
    render: (_, { ClientServiceId }) => (
      <Button
        type="text"
        danger
        icon={<DeleteOutlined />}
        onClick={() => onRemove(ClientServiceId)}
        aria-label="Убрать услугу из абонемента"
        data-testid="subscription-row-remove"
      />
    ),
  },
];
